import { useMemo } from 'react';

import { mapValues } from 'lodash-es';

import { useBanditCopy } from './useBanditCopy';
import type { TranslationName } from './useCopyI18nKeys';
import { useCopyI18nKeys } from './useCopyI18nKeys';

type Result = ModelHookResult<Record<TranslationName, string>>;

export function usePageCopy(): Result {
	const {
		data: { keys },
		actions: { translateKey },
	} = useCopyI18nKeys();
	const {
		data: { copy: banditLabels },
		actions: { processLabel: processBanditLabel },
	} = useBanditCopy();

	const base = useMemo(() => {
		return mapValues(
			keys,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(i18nKey, name) => translateKey(name as TranslationName, i18nKey),
		);
	}, [keys, translateKey]);

	const banditOverrides = useMemo(() => {
		return mapValues(banditLabels, (label) => processBanditLabel(label || ''));
	}, [banditLabels, processBanditLabel]);

	return {
		data: useMemo(() => {
			return { ...base, ...banditOverrides };
		}, [base, banditOverrides]),
	};
}
